import { Popover, Box } from "@mui/material";
import MenuListUser from "./MenuListUser";

export default function MenuUserPopover({
  open,
  anchorEl,
  handleClose,
  name,
  email,
}) {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <Box sx={{ width: 320, maxWidth: "100%" }}>
        <MenuListUser name={name} email={email} />
      </Box>
    </Popover>
  );
}
